import { observer } from 'mobx-react';
import { FC, useCallback, useEffect } from 'react';
import ScrollableBlock from '../../ScrollableBlock/ScrollableBlock';
import CustomerWalletModalMode from './components/CustomerWalletModalMode/CustomerWalletModalMode';
import CustomerWalletModalCorrectBlock from './containers/CustomerWalletModalCorrectBlock/CustomerWalletModalCorrectBlock';
import CustomerWalletModalTopUpBlock from './containers/CustomerWalletModalTopUpBlock/CustomerWalletModalTopUpBlock';
import { customerWalletModalStore } from './store';
import { localeStore } from 'src/mobx/localesStore';
import Button from 'src/view/components/Controls/ButtonComponent/Button';
import CustomModalComponent from 'src/view/components/Controls/Modal/Modal';
import ModalBackground from 'src/view/components/Controls/Modal/ModalBackground/ModalBackground';
import ModalFooter from 'src/view/components/Controls/Modal/ModalFooter/ModalFooter';
import ModalHeader from 'src/view/components/Controls/Modal/ModalHeader/ModalHeader';
import './style.scss';
import { BUTTON_TITLE } from '~/constants/main';

const CustomerWalletModal: FC = observer((): JSX.Element => {
  const { loading, isTopUpMode, currentWalletNumbers } = customerWalletModalStore;

  useEffect(() => {
    customerWalletModalStore.initStore();
  }, []);

  const onUpdate = useCallback(() => {
    customerWalletModalStore.setValidation();

    if (customerWalletModalStore.validation.isValid) customerWalletModalStore.submit();
  }, []);

  return (
    <CustomModalComponent
      isOpen
      withCloseIcon
      onRequestClose={customerWalletModalStore.closeModal}
      contentStyle={{ height: customerWalletModalStore.modalHeight }}
      className="customer-wallet-modal">
      <ModalBackground>
        <ModalHeader title={localeStore.t('update_wallet')} />
        <ScrollableBlock showScrollbar className="d-flex flex-1 mx-8 mt-6 mb-4" scrollClassName="full-height">
          <CustomerWalletModalMode />
          <CustomerWalletModalTopUpBlock />
          <CustomerWalletModalCorrectBlock />
        </ScrollableBlock>
        <ModalFooter>
          <Button
            title={localeStore.t(BUTTON_TITLE.SAVE)}
            onClick={onUpdate}
            loading={loading}
            disabled={!isTopUpMode && !currentWalletNumbers}
            size="large"
          />
        </ModalFooter>
      </ModalBackground>
    </CustomModalComponent>
  );
});

export default CustomerWalletModal;
